import { render, staticRenderFns } from "./inspection-image.vue?vue&type=template&id=a90a8800&scoped=true"
import script from "./inspection-image.vue?vue&type=script&lang=js"
export * from "./inspection-image.vue?vue&type=script&lang=js"
import style0 from "./inspection-image.vue?vue&type=style&index=0&id=a90a8800&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90a8800",
  null
  
)

export default component.exports